module.exports = __webpack_public_path__ + "img/howtopwbaus.7eb03fa7.jpg";